import { ReactComponent as SearchIcon } from '../Icons/Search.svg';
import { ReactComponent as ClearIcon } from '../Icons/Circle_cancel.svg';
import ColorScheme from '../ColorScheme/ColorScheme';
import '../index.css';
import { useEffect, useMemo, useState } from 'react';
import { debounce as debounceFunc } from 'lodash';
import SearchThemes from './SearchThemes';

const Search = ({
    className = '',
    id,
    width = '200px',
    theme,
    placeholder = 'Search...',
    debounce = 300,
    onChange = () => {}
}) => {
    const [value, setValue] = useState('');
    const [inFocus, setInFocus] = useState('');
    const [clearHover, setClearHover] = useState('');

    const colorMapper = SearchThemes[theme] || SearchThemes.Light;

    const changeHandler = useMemo(
        () =>
            debounceFunc((val) => {
                onChange(val);
            }, debounce),
        [onChange, debounce]
    );

    useEffect(() => {
        setValue('');
    }, [id]);

    return (
        <div
            id={id}
            className={`rounded-lg font-sf h-8 p-2 flex items-center  bg-${colorMapper.background} hover:bg-${colorMapper.backgroundHover} ${className}`}
            style={{ width }}>
            <SearchIcon
                className="w-4 h-4 mr-0.5"
                fill={ColorScheme[inFocus ? colorMapper.icon : colorMapper.iconDisabled]}
            />

            <input
                id={`${id}-searchInput`}
                type="text"
                className={`px-0.5 w-full bg-transparent border-none outline-none text-13 text-${colorMapper.text} placeholder:text-${colorMapper.placeholder}`}
                name="searchInput"
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    setValue(e.target.value);
                    changeHandler(e.target.value);
                }}
                autoComplete="off"
                focus={inFocus}
                onFocus={() => setInFocus('true')}
                onBlur={() => setInFocus('false')}
            />
            {value && (
                <ClearIcon
                    className="w-3 h-3 cursor-pointer"
                    onMouseEnter={() => setClearHover(true)}
                    onMouseLeave={() => setClearHover(false)}
                    onClick={() => {
                        setValue('');
                        setClearHover(false);
                        onChange('');
                    }}
                    fill={ColorScheme[clearHover ? 'sf-gray-700' : 'sf-gray-400']}
                />
            )}
        </div>
    );
};

export default Search;
